// @flow

import React from 'react';
import { Row } from 'react-bootstrap/lib';
import styler from 'react-styling';

import { ContactAvatar } from './index';

const style = styler `
  Row
    margin-left: 0px
  Name
    margin-top: 5px
  `;

type Props = {
    imagePath?: string,
    displayName: string,
  }

const ContactItem = (props: Props) => (
  <Row style={style.Row}>
    <ContactAvatar displayName={props.displayName} width="30px" height="30px" radius="30px" margin="0 15px" fontSize="14px" textAlign="center" imagePath={props.imagePath} padding="0 15px" />
    <p className="list-displayName" style={style.Name}>{props.displayName}</p>
  </Row>
);

export default ContactItem;



// WEBPACK FOOTER //
// ./src/js/Components/ContactItem.js